import Strings from "../Strings";
import { DeviceTypes } from "./deviceTypes";
import { isSuperUser } from "./userRoles";

export const VITALS = {
  TEMPERATURE: 'temperature',
  WEIGHT: 'weight',
  HEIGHT: 'height',
  PRESSURE_SYSTOLIC: 'pressure_systolic',
  PRESSURE_DIASTOLIC: 'pressure_diastolic',
  HEART_RATE: 'heart_rate',
  SLEEP: 'sleep',
  STEPS: 'steps',
  PILLS_TAKEN: 'pills_taken',
  SUGAR_LEVEL: 'sugar_level',
  OXYGEN_SATURATION: 'oxygen_saturation',
  PEAK_EXPIRATORY_FLOW: 'peak_expiratory_flow',
  FORCED_EXPIRATORY_VOLUME_1S: 'forced_expiratory_volume_1s',
  FORCED_VITAL_CAPACITY: 'forced_vital_capacity',
  NUMBER_OF_SHAKES: 'number_of_shakes',
  SHAKES_DURATION: 'shakes_duration',
  ORIENTATION: 'orientation',
  COORDINATION: 'coordination',
  INHALATION_DURATION: 'inhalation_duration',
  EXERCISE_DURATION: 'exercise_duration',
  EXERCISE_AMOUNT: 'exercise_amount',
  BURNED_CALORIES: 'burned_calories',
  DISTANCE: 'distance',
  INHALATION_TAKEN: 'inhalation_taken',
  PM25: 'pm25',
  PROTHROMBIN_TIME: 'prothrombin_time',
  INTERNATIONAL_NORMALIZED_RATIO: 'international_normalized_ratio',
  MEAN_ARTERIAL_PRESSURE: 'mean_arterial_pressure',
  PERFUSION_INDEX: 'perfusion_index',
};

export const KPIS = {
  vitals: {
    id: 'vitals',
    name: Strings.vitals,
    kpis: VITALS,
  },
  adherence: {
    id: 'adherence',
    name: Strings.adherence,
    kpis: {
      missed_doses: 'missed_doses'
    },
  },
  enrollment: {
    id: 'enrollment',
    name: Strings.enrollment,
    kpis: {
      missing_mandatory_tasks: 'missing_mandatory_tasks',
      missing_cpt: 'missing_cpt',
    }
  },
  devices: {
    id: 'devices',
    name: Strings.devices,
    kpis: {
      battery_level: 'battery_level',
      signal_level: 'signal_level',
      fault: 'fault'
    },
  }
};

const deviceMappingGroupPresentation = {
  temperature: { label: Strings.temperature, value: 'Temperature', deviceTypes: [DeviceTypes.Thermometer] },
  weight: { label: Strings.weight, value: 'Weight', deviceTypes: [DeviceTypes["Weighing Machine"]] },
  blood_pressure: { label: Strings.bloodPressure, value: 'BloodPressure', deviceTypes: [DeviceTypes["Blood Pressure Monitor"]] },
  heart_rate: { label: Strings.heartRate, value: 'HeartRate', deviceTypes: [DeviceTypes["Blood Pressure Monitor"], DeviceTypes["Wrist Band"], DeviceTypes["Pulse Oximeter"]] },
  sleep: { label: Strings.sleepDuration, value: 'Sleep', deviceTypes: [DeviceTypes["Wrist Band"]] },
  steps: { label: Strings.steps, value: 'Steps', deviceTypes: [DeviceTypes["Wrist Band"]] },
  sugar_level: { label: Strings.glucoseConcentration, value: 'SugarLevel', deviceTypes: [DeviceTypes["Glucometer"]] },
  oxygen_saturation: { label: Strings.oxygenSaturation, value: 'OxygenSaturation', deviceTypes: [DeviceTypes["Pulse Oximeter"]] },
  spirometry: { label: Strings.spirometry, value: 'Spirometry', deviceTypes: [DeviceTypes["Spirometer"]] },
  exercise_details: { label: Strings.exerciseDetails, value: 'ExerciseDetails', deviceTypes: [DeviceTypes["Wrist Band"]] },
  air_quality: { label: Strings.airQuality, value: 'AirQuality', deviceTypes: [DeviceTypes["Air Quality Monitor"]] },
  coagulation: { label: Strings.coagulation, value: 'Coagulation', deviceTypes: [DeviceTypes["PT/INR Monitor"]] },
  pills_taken: { label: Strings.takes, value: 'PillsTaken', deviceTypes: [DeviceTypes["Bluetooth Cap"], DeviceTypes["LTE Medication Organizer"], DeviceTypes["LTE Pillbox"], DeviceTypes["LTE Smart Cap"], DeviceTypes["MDP Dispenser"]] },
  inhalations: { label: Strings.inhalations, value: 'Inhalations', deviceTypes: [DeviceTypes.Inhaler, DeviceTypes["Hailie Inhaler"]] },
};

export const getVitalsForPermissions = (permissions, mappingGroups = []) => mappingGroups
  .map(group => {
    const presentation = deviceMappingGroupPresentation[group.key];
    return presentation ? { ...presentation, key: group.key, vitals: group.vital_types } : null;
  })
  .filter(group => group
    && (group.deviceTypes.some(dt => permissions.includes(dt.permission)) || isSuperUser()));
